import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { fetchSecurityState, setupRedirect } from "@/lib/security";

export function SecurityGate({ children }: { children: React.ReactNode }) {
  const [to, setTo] = useState<string | null>(null);
  useEffect(() => {
    let live = true;
    fetchSecurityState().then((s) => live && setTo(setupRedirect(s)));
    return () => { live = false; };
  }, []);
  if (to) return <Navigate to={to} replace />;
  return <>{children}</>;
}
